import { render } from "./index.vue?vue&type=template&id=4ecb4221&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4ecb4221&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4ecb4221"

export default script